import { Icon, SvgUndo } from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ROLLOUT_WEAVE, VARIANT } from 'constants/featureFlag';
import { V6 } from 'constants/recordingVersions';
import { watchAgain } from 'creators/videoPlayer';
import { selectVideo } from 'selectors/videoPlayer';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import ControlBarButton from '../control-bar-button';

import { useClipsState } from 'components/share-video/edit-tools/clips/state';

export default function WatchAgainButton(props) {
  const dispatch = useDispatch();
  const {
    clips,
    focusedClipIndex,
    updateFocusedClipIndex,
    updateFocusedPlayRangeIndex,
  } = useClipsState(state => ({
    clips: state.clips,
    focusedClipIndex: state.focusedClipIndex,
    updateFocusedClipIndex: state.updateFocusedClipIndex,
    updateFocusedPlayRangeIndex: state.updateFocusedPlayRangeIndex,
  }));

  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);
  const video = useSelector(selectVideo);

  const handleWatchAgain = () => {
    // if we aren't at the first clip, force going back to it:
    let targetClip = null;

    const isWeavable = video.video_properties?.recording_version === V6;

    if (rolloutWeave && isWeavable && focusedClipIndex > 0) {
      // we aren't playing the first clip, we should swap clips to get back to it
      targetClip = clips[0];

      dispatch(
        watchAgain({
          targetClip,
          updateFocusedClipIndex,
          updateFocusedPlayRangeIndex,
        })
      );
    } else {
      dispatch(watchAgain());
    }
  };

  return (
    <ControlBarButton
      className="video-player-watch-again-button"
      hoverTagText="Watch Again"
      seeking={props.seeking}
      onClick={handleWatchAgain}
      addLeftMargin="16px"
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgUndo />}
      />
    </ControlBarButton>
  );
}
